import { Dialog, DialogContent, Grid, TextField, DialogActions } from "@material-ui/core";
import { useState, useEffect, useContext } from "react";
import { SDialogTitle, SDialogButton } from "./common/BCommonComponents";
import { UserRole } from "./common/Dtos";
import AuthContext from "./auth/AuthContext";
import { toast } from 'react-toastify';

interface CambioPasswordDialogProps {
	open: boolean;
	canClose: boolean;
	userId: string | null;
	onClose: (newPassword?: string) => void;
}

export function CambioPasswordDialog(props: CambioPasswordDialogProps) {
	const auth = useContext(AuthContext);
	const {onClose, open, canClose, userId} = props;
	const [newPassword, setNewPassword] = useState('');
	const [repeatNewPassword, setRepeatNewPassword] = useState('');
	const [errorRepeat, setErrorRepeat] = useState<boolean>(false);
	const [errorNotValid, setErrorNotValid] = useState<boolean>(false);
	const [errorSamePsw, setErrorSamePsw] = useState<boolean>(false);

	const reagexPassowrd = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

	useEffect(() => {
		setNewPassword('');
		setRepeatNewPassword('');
		setErrorRepeat(false);
		setErrorNotValid(false);
	}, [open])

	const handleNewPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNewPassword(event.target.value);
	}

	const handleRepeatPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRepeatNewPassword(event.target.value);
	}

	const handleClose = () => {
		if (auth.state.roles && checkRole() && auth.state.id !== userId) {
			setErrorNotValid(false);
			setErrorRepeat(false);
			setErrorSamePsw(false);
			onClose(newPassword);
		} else {
			if (newPassword !== repeatNewPassword) {
				setErrorRepeat(true);
				setErrorNotValid(false);
				setErrorSamePsw(false);
			} else if (!reagexPassowrd.test(newPassword)) {
				setErrorRepeat(false);
				setErrorNotValid(true);
				setErrorSamePsw(false);
			} else {
				setErrorNotValid(false);
				setErrorRepeat(false);

				const encodedPsw = btoa(newPassword);
				auth.state.axiosInstance?.post('/api/accounts/check-same-password', {id: auth.state.id, newPassword: encodedPsw})
					.then(res => {
						console.log('check-same-password', res);
						const samePsw = res.data;
						if (!samePsw) {
							onClose(newPassword);
							setErrorSamePsw(false);
						} else {
							setErrorSamePsw(true);
						}
					})
					.catch(error => {
						toast.error('🛑 Errore durante la verifica della password');
						console.log(error);
					});

			}
		}
	}

	const checkRole = () => {
		if (auth.state.roles && ((auth.state.roles.indexOf(UserRole.ADMIN) != -1)
			|| (auth.state.roles.indexOf(UserRole.SUPERVISOR) != -1)
			|| (auth.state.roles.indexOf(UserRole.RESPONSIBLE) != -1))) {
			return true;
		} else {
			return false;
		}
	}

	return (
		<Dialog
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">Modifica Password</SDialogTitle>
			<DialogContent>
				{(auth.state.id === userId) &&
					<div>
						<p style={{marginBottom: '10px', color: 'grey'}}>La password deve contenere un minimo di 8 caratteri con almeno 1 lettera, 1 numero, 1 maiuscola, 1 minuscola e 1 carattere speciale
							(.*[!@#$%^&*]) e dovrà essere rinnovata regolarmente.</p>
					</div>
				}
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12}>
						<TextField
							className="w-100"
							id="newPassword"
							label="Nuova Password"
							variant="outlined"
							type="password"
							InputLabelProps={{shrink: true}}
							value={newPassword}
							onChange={handleNewPasswordChange}
							error={errorNotValid || errorSamePsw}
							helperText={errorNotValid ? "La password non corrisponde ai criteri indicati." :
								errorSamePsw ? "La password non può essere uguale all'ultima utilizzata" : ""}
						/>
					</Grid>
					<Grid item xs={12} className="mt-3">
						<TextField
							className="w-100"
							id="repeatPassword"
							label="Ripeti Password"
							variant="outlined"
							type="password"
							InputLabelProps={{shrink: true}}
							value={repeatNewPassword}
							onChange={handleRepeatPasswordChange}
							error={errorRepeat}
							helperText={errorRepeat && "Le due password devono corrispondere"}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleClose}>CONFERMA</SDialogButton>
				{canClose &&
					<SDialogButton variantcolor="secondary" className="float-right" onClick={() => {
						onClose();
					}}>ANNULLA</SDialogButton>
				}
			</DialogActions>
		</Dialog>
	);
}
